export const SET_ROLES_LOADED = "SET_ROLES_LOADED";

export const setRolesLoaded = (rolesLoaded: boolean) => {
  return {
    rolesLoaded,
    type: SET_ROLES_LOADED
  };
};
